import React from "react";
import { buildImageObj } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;

const Overlay = styled.div`
  width: 80%;
  text-align: center;
  margin: 0px auto;
  position: absolute;
  left: 0;
  right: 50%;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 1;
`;

// const BgImage = styled(GatsbyImage)`
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   z-index: 1;
//   height: ${props => props.height || "100vh"};
//   /* // Adjust image positioning (if image covers area with defined height) and add font-family for polyfill */
//   & > img {
//     object-fit: ${props => props.fit || "cover"} !important;
//     object-position: ${props => props.position || "50% 50%"} !important;
//     font-family: 'object-fit: ${props =>
//       props.fit || "cover"} !important; object-position: ${props =>
//   props.position || "50% 50%"} !important;'
//   }
// `;

function Hero(props) {
  const { children, mainImage } = props;

  return (
    <Container>
      <img
      data-testid="hero-image"
        style={{ width: "100%" }}
        src={imageUrlFor(buildImageObj(mainImage)).url()}
        title={`${mainImage.caption}`}
        alt={mainImage.alt}
        caption={mainImage.caption}
      />
      <div className="overlay">{children}</div>
    </Container>
  );
}

export default Hero;
